import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils.js";

interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export const LoadingSpinner = ({
  size = 24,
  className,
}: LoadingSpinnerProps) => {
  return (
    <div className="flex items-center justify-center p-4">
      <Loader2 size={size} className={cn("animate-spin", className)} />
    </div>
  );
};
